import {
  classNamesFunction,
  FontWeights,
  IButtonStyles,
  IDropdownStyles,
  ILabelStyles,
  ISpinnerStyles,
  ITextFieldStyles
} from 'office-ui-fabric-react';

import { ICommonStyles, IComponentStyleProps } from '../../../types';
import { getCustomStyles } from '../../intentGraph.styles';

const _getDiagnosticFormStyles = (props: IComponentStyleProps) => {
  const { theme, stylesFunc } = props;
  const c = getCustomStyles(theme, stylesFunc);
  if (c) {
    if (c.safActionNode) {
      return c.safActionNode.inlineDiagnostics.diagnostcForm;
    } else if (c.safNode) {
      return c.safNode.diagnostcForm;
    }
  }
  return {};
};

export const getCommonStyles = (props: IComponentStyleProps): Partial<ICommonStyles> => {
  const diagFormStyles = _getDiagnosticFormStyles(props);
  const customStyles = diagFormStyles.common ? diagFormStyles.common : {};
  const defaultStyles = {
    contentContainer: {
      marginBottom: '16px'
    },
    sectionHeader: {
      fontWeight: '600',
      fontSize: '14px',
      lineHeight: '20px'
    },
    title: {
      fontSize: '16px',
      fontWeight: '600'
    }
  };
  return { ...defaultStyles, ...customStyles } as Partial<ICommonStyles>;
};

export const getFormTextFieldStyles = (props: IComponentStyleProps): Partial<ITextFieldStyles> => {
  const diagFormStyles = _getDiagnosticFormStyles(props);
  const customStyles = diagFormStyles.textField ? diagFormStyles.textField : {};
  const defaultStyles = {
    subComponentStyles: {
      label: {
        root: {
          fontWeight: '600'
        }
      }
    }
  };
  return { ...defaultStyles, ...customStyles } as Partial<IDropdownStyles>;
};

export const getFormDropDownStyles = (props: IComponentStyleProps): Partial<IDropdownStyles> => {
  const diagFormStyles = _getDiagnosticFormStyles(props);
  const customStyles = diagFormStyles.dropdown ? diagFormStyles.dropdown : {};
  const defaultStyles = {
    label: {
      fontWeight: '600'
    }
  };
  return { ...defaultStyles, ...customStyles } as Partial<IDropdownStyles>;
};

export const getFormDatePickerLabelStyles = (props: IComponentStyleProps): Partial<ILabelStyles> => {
  const diagFormStyles = _getDiagnosticFormStyles(props);
  const customStyles = diagFormStyles.datePicker ? diagFormStyles.datePicker : {};
  const defaultStyles = {
    root: {
      fontWeight: '600'
    }
  };
  return { ...defaultStyles, ...customStyles } as Partial<ILabelStyles>;
};

export const getFormBtnStyles = (props: IComponentStyleProps): Partial<IButtonStyles> => {
  const diagFormStyles = _getDiagnosticFormStyles(props);
  const { theme } = props;
  const customStyles = diagFormStyles.button ? diagFormStyles.button : {};

  const defaultStyles = {
  };
  return { ...defaultStyles, ...customStyles } as Partial<IButtonStyles>;
};

export const getDropDownSpinnerStyles = (props: IComponentStyleProps): ISpinnerStyles => {
  const diagFormStyles = _getDiagnosticFormStyles(props);
  const customStyles = diagFormStyles.dropDownSpinner ? diagFormStyles.dropDownSpinner : {};
  const defaultStyles = { root: { position: 'relative' } };

  return { ...defaultStyles, ...customStyles } as Partial<ILabelStyles>;
};

export const getCommonClassNames = classNamesFunction<{}, ICommonStyles>();
